// extracted by mini-css-extract-plugin
export default {"modal":"JE-z","addItemButton":"KE-z","plusCircle":"LE-z","branchVisible":"ME-z"};